// ── Funnel tracking: capture URL parameter on page load ──
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var funnelSource = urlParams.get('funnel');
  if (funnelSource) {
    sessionStorage.setItem('funnel_source', funnelSource);
  }
})();

function setFunnelCartAttribute() {
  var funnelSource = sessionStorage.getItem('funnel_source');
  if (funnelSource) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: 'funnel_source=' + funnelSource })
    });
  }
  return Promise.resolve();
}

const formSteps = document.querySelector('.form-steps');
const form = document.querySelector('.form');
const progress = document.querySelectorAll('.step');
const prevBtn = document.querySelectorAll('.back');
const nextBtn = document.querySelectorAll('.next');

let currentStep = 0;

// show the current step
function showStep(stepIndex) {
    const fieldsets = form.querySelectorAll('fieldset.form_step');
    fieldsets.forEach((fieldset) => {
        fieldset.classList.remove('active');
    });
    fieldsets[stepIndex].classList.add('active');
    updateProgressBar(stepIndex);

    // Accessibility: announce step change and move focus
    var stepNum = stepIndex + 1;
    var announcer = document.getElementById('step-announcer');
    var stepNames = { 1: 'Passo 1: Quanti gatti hai?', 2: 'Passo 2: Scegli il tuo piano' };
    if (announcer && stepNames[stepNum]) announcer.textContent = stepNames[stepNum];
    var target = fieldsets[stepIndex];
    var heading = target ? target.querySelector('h2, .step-question, .form h2, .h2') : null;
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus(); }
}

// update the progress bar
function updateProgressBar(currentStep) {
    progress.forEach((step, index) => {
        if (index <= currentStep) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

function fromURL() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const step = urlParams.get('step')
    const step1_option = urlParams.get('step1_option')
    const step2_option = urlParams.get('step2_option')


    if (step != null) {
        currentStep = parseInt(step) - 1
        document.querySelectorAll('.form_step').forEach((step) => {
            step.classList.remove('active')
        })
        document.querySelector('.form_step.step' + step).classList.add('active')
    }

    if (step1_option != null) {
        document.querySelectorAll('.form_step.step1 .option').forEach((option) => {
            option.classList.remove('active')
        })
        document.querySelectorAll('.form_step.step1 .option')[(step1_option - 1)].classList.add('active')
    }

    if (step2_option != null) {
        document.querySelectorAll('.form_step.step2 .option').forEach((option) => {
            option.classList.remove('active')
        })
        document.querySelectorAll('.form_step.step2 .option')[(step2_option - 1)].classList.add('active')
    }
}

// go to the previous step
function prevStep() {
    if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
    }
}

// go to the next step
function nextStep() {
    if (currentStep < progress.length - 1) {
        currentStep++;
        showStep(currentStep);
    }
}

// go back to home
function backToHome() {
    formSteps.style.display = 'none';
    // add your own code to redirect to the home page or hide the form
}

function selectOption(optionSelected, step_number) {
    document.querySelector('.form .step' + step_number).querySelectorAll('.option').forEach((option) => {
        option.classList.remove('active');
        var radio = option.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
    })
    optionSelected.classList.add('active');
    var selectedRadio = optionSelected.querySelector('input[type="radio"]');
    if (selectedRadio) selectedRadio.checked = true;
    updateCurrentSelectedOffer()
    showBadge();
    showMention();
    showMentionText();
}

function updateCurrentSelectedOffer() {
    var first_key = document.querySelectorAll('.form_step .option.active')[0].dataset.combinaisonKey
    var second_key = document.querySelectorAll('.form_step .option.active')[1].dataset.combinaisonKey
    document.querySelectorAll('.issue').forEach((issue) => {
        if (issue.dataset.combinaisonKey == first_key + second_key) {
            issue.classList.add('active')
        } else {
            issue.classList.remove('active')
        }
    });
}

function getCurrentSelectedOfferID() {
    return parseInt(document.querySelector('.issue.active').dataset.variantId)
}

function getCurrentSelectedOfferPlanID() {
    return parseInt(document.querySelector('.issue.active').dataset.sellingplanId)
}

function showPopup() {
    document.getElementById("form-popup").style.display = "flex";
}

function closePopup() {
    document.getElementById("form-popup").style.display = "none";
}

function takeOffer(offer) {
    closePopup()
    document.querySelector('.form_step.step2').querySelector('.option[data-combinaison-key="' + offer + '"]').click()
    document.querySelector('.next-checkout').click()
}


function checkoutWithNoUpsell() {
    let formData = {
        'items': [{
            'id': getCurrentSelectedOfferID(),
            'selling_plan': getCurrentSelectedOfferPlanID(),
            'quantity': 1
        }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => response.json())
        .then(() => setFunnelCartAttribute())
        .then(() => {
            location.href = '/checkout';
        })
        .catch((error) => {
            location.href = '/checkout';
        });
}

function checkout(popup_id = null) {
    var popupTriggered = false
    if (popup_id != null && !document.querySelector('.next-checkout').classList.contains('popupTriggered')) {
        document.querySelectorAll('.form_step').forEach((step) => {
            if (step.querySelector('.option.active') != null && step.querySelector('.option.active').dataset.combinaisonKey == popup_id) {
                showPopup()
                popupTriggered = true
                document.querySelector('.next-checkout').classList.add('popupTriggered')
            }
        })
    }

    if (!popupTriggered) {
        let formData = {
            'items': [{
                'id': getCurrentSelectedOfferID(),
                'selling_plan': getCurrentSelectedOfferPlanID(),
                'quantity': 1
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(() => setFunnelCartAttribute())
            .then(() => {
                location.href = '/checkout';
            })
            .catch((error) => {
                location.href = '/checkout';
            });
    }
}

function showBadge() {
    document.querySelectorAll('.option-badge, .popup-badge').forEach((badge) => {
        badge.classList.remove('active')
    })
    document.querySelector('.option-badge[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
    document.querySelector('.popup-badge[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
}

function showMentionText() {
    document.querySelectorAll('.option-mention').forEach((mention) => {
        mention.classList.remove('active');
    });
    document.querySelectorAll('.option-mention[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').forEach((mention) => {
        mention.classList.add('active');
    });
    console.log(document.querySelector('.form .step1 .option.active'))
}

function showMention() {
    document.querySelectorAll('.popup-mention').forEach((badge) => {
        badge.classList.remove('active')
    })
    document.querySelectorAll('.title-popup-titre').forEach((titre) => {
        titre.classList.remove('active')
    })
    document.querySelectorAll('.title-popup-description').forEach((description) => {
        description.classList.remove('active')
    })
    document.querySelector('.popup-mention[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
    document.querySelector('.popup-mention[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
  
    document.querySelector('.title-popup-titre[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
    document.querySelector('.title-popup-titre[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')

    document.querySelector('.title-popup-description[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
    document.querySelector('.title-popup-description[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
}

// initialize the form
function initForm() {
    showStep(currentStep);

    document.querySelector('.form .step1').querySelectorAll('.option')[0].classList.add('active')
    document.querySelector('.form .step2').querySelectorAll('.option')[1].classList.add('active')

    prevBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            prevStep();
        });
    });

    nextBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            nextStep();
        });
    });
    updateCurrentSelectedOffer();
    showBadge()
    showMention()
    showMentionText()
    fromURL()
}

initForm();
